import { Box, VStack, useBreakpointValue } from '@chakra-ui/react';
import { CatalogSidebarFilters } from '../components/SearchSidebar';
import { CollectionHoleControls } from '../components/collection/CollectionHoleControls';
import { CollectionLanguageControl } from '../components/collection/CollectionLanguageControl';
import { useAuth } from '../hooks/useAuth';
import { useDebouncedUrlSearchTerm } from '../hooks/useDebouncedUrlSearchTerm';
import { useSearchState } from './useSearchState';

export function CollectionSidebarBound() {
  const { user } = useAuth();
  const { localTerm, setLocalTerm, filter, setFilter, handleCommitSearch, handleCommitFacet } =
    useDebouncedUrlSearchTerm();
  const {
    collectionHoleOnly,
    collectionGoal,
    collectionLanguage,
    setCollectionHoleOnly,
    setCollectionGoal,
    setCollectionLanguage,
  } = useSearchState();
  // The page segment owns this below desktop. Counting it here would badge sidebar reset.
  const countHoleAsFilter = useBreakpointValue({ base: false, lg: true }) ?? false;

  return (
    <VStack align="stretch" gap={3}>
      {user ? (
        <Box display={{ base: 'none', lg: 'block' }} flexShrink={0}>
          {user.collectionLanguageEnabled ? (
            <CollectionLanguageControl
              value={collectionLanguage}
              onChange={setCollectionLanguage}
              newCopyLanguage={user.collectionDefaultLanguage}
            />
          ) : null}
          <CollectionHoleControls
            holeOnly={collectionHoleOnly}
            onHoleOnlyChange={setCollectionHoleOnly}
            goal={collectionGoal}
            onGoalChange={setCollectionGoal}
            noSetSelected={filter.set.length === 0}
          />
        </Box>
      ) : null}
      <CatalogSidebarFilters
        filter={filter}
        setFilter={setFilter}
        searchTerm={localTerm}
        setSearchTerm={setLocalTerm}
        onCommitSearch={handleCommitSearch}
        onCommitFacet={handleCommitFacet}
        extraActiveFilterCount={countHoleAsFilter && user && collectionHoleOnly ? 1 : 0}
      />
    </VStack>
  );
}
